import React from 'react';
import { isFeatureEnabled } from '../../helpers/features';
import type { SurveyHostedQuestion } from '../../types';
import MultipleChoice from './MultipleChoice';
import Checkbox from './Checkbox';
import Text from './Text';
import Email from './Email';
import Range from './Range';
import ContactInformation from './ContactInformation';
import Dropdown from './Dropdown';
import stylesheet from './Question.css';

type Props = {
  handleEditResponse: $TSFixMeFunction;
  question: SurveyHostedQuestion;
  onChange: $TSFixMeFunction;
};

const Question = (props: Props) => {
  const { question } = props;
  let input;
  const questionResponse = question.response;
  const dropdownQuestionEnabled = !!isFeatureEnabled(
    'add_html_select_element_feature_to_surveys',
  );
  if (
    questionResponse === 'pickOne' ||
    (questionResponse === 'dropdown' && dropdownQuestionEnabled === false)
  ) {
    input = <MultipleChoice {...props} />;
  } else if (questionResponse === 'pickMany') {
    input = <Checkbox {...props} />;
  } else if (questionResponse === 'text') {
    input = <Text {...props} />;
  } else if (questionResponse === 'range') {
    // @ts-expect-error TS2741
    input = <Range {...props} />;
  } else if (questionResponse === 'dropdown') {
    input = <Dropdown {...props} />;
  } else if (questionResponse === 'email') {
    input = <Email {...props} />;
  } else if (questionResponse === 'contactInformation') {
    input = <ContactInformation {...props} />;
  } else {
    input = <Text {...props} />;
  }

  return <div className={stylesheet.questionContainer}>{input}</div>;
};

export default Question;
